import React from 'react';
import { SaveStatus } from '../../../types/assessment-progress';
import { getRelativeTime } from '../../../utils/assessmentStorage';
import styles from './SaveIndicator.module.css';

interface SaveIndicatorProps {
  saveStatus: SaveStatus;
  className?: string;
}

/**
 * Visual indicator for auto-save status
 * Shows: Saving..., Saved ✓, or Error states
 */
export const SaveIndicator: React.FC<SaveIndicatorProps> = ({ saveStatus, className }) => {
  const { isSaving, lastSaved, error } = saveStatus;

  if (error) {
    return (
      <div className={`${styles.indicator} ${styles.error} ${className || ''}`}>
        <i className="fas fa-exclamation-circle"></i>
        <span>Error saving progress</span>
      </div>
    );
  }

  if (isSaving) {
    return (
      <div className={`${styles.indicator} ${styles.saving} ${className || ''}`}>
        <i className="fas fa-circle-notch fa-spin"></i>
        <span>Saving...</span>
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div className={`${styles.indicator} ${styles.saved} ${className || ''}`}>
        <i className="fas fa-check-circle"></i>
        <span>Saved {getRelativeTime(lastSaved)}</span>
      </div>
    );
  }

  return null;
};

export default SaveIndicator;

